const LOG_TYPES = {
  DELETE_ALL_PRODUCTS: "DELETE_ALL_PRODUCTS",
  DELETE_PRODUCT_VARIANTS: "DELETE_PRODUCT_VARIANTS",
  DELETE_PRODUCT: "DELETE_PRODUCT",
  ADD_PRODUCTS: "ADD_PRODUCTS",
  UPDATE_PRODUCTS: "UPDATE_PRODUCTS",
  UPDATE_VARIANT: "UPDATE_VARIANT",
  ADD_SELLING_PLAN: "ADD_SELLING_PLAN",
  UPDATE_SELLING_PLAN: "UPDATE_SELLING_PLAN",
  DELETE_SELLING_PLAN: "DELETE_SELLING_PLAN",
  ADD_TEMPLATE: "ADD_TEMPLATE",
  UPDATE_TEMPLATE: "UPDATE_TEMPLATE",
  DELETE_TEMPLATE: "DELETE_TEMPLATE",
  UPDATE_PO_NOTIFICATION_EMAIL: "UPDATE_PO_NOTIFICATION_EMAIL",
  UPDATE_SHIPPING_DELAY_EMAIL: "UPDATE_SHIPPING_DELAY_EMAIL",
  UPDATE_BACK_IN_STOCK_EMAIL: "UPDATE_BACK_IN_STOCK_EMAIL",
  DELETE_BIS_NOTIFICATION: "DELETE_BIS_NOTIFICATION",
  DELETE_ORDER: "DELETE_ORDER",
};

const ACTION_TYPE_COLORS = {
  DELETE: "error",
  UPDATE: "info",
  ADD: "success",
};

const LOG_ACTIONS = {
  [LOG_TYPES.DELETE_ALL_PRODUCTS]: (type) => {
    return {
      message: `Delete all ${type} products`,
      actionType: LOG_TYPES.DELETE_ALL_PRODUCTS,
    };
  },
  [LOG_TYPES.DELETE_PRODUCT_VARIANTS]: ({ count, productTitle }) => {
    return {
      message: `Delete ${count} ${count > 1 ? "variants" : "variant"} product ${productTitle}`,
      actionType: LOG_TYPES.DELETE_PRODUCT_VARIANTS,
    };
  },
  [LOG_TYPES.DELETE_PRODUCT]: (productTitle) => {
    return {
      message: `Delete product: Product ${productTitle} has been deleted.`,
      actionType: LOG_TYPES.DELETE_PRODUCT,
    };
  },
  [LOG_TYPES.ADD_PRODUCTS]: ({ productCount, variantCount }) => {
    return {
      message: `Add ${productCount} products (${variantCount} product variants).`,
      actionType: LOG_TYPES.ADD_PRODUCTS,
    };
  },
  [LOG_TYPES.UPDATE_PRODUCTS]: ({ productCount, variantCount }) => {
    return {
      message: `Update ${productCount} products (${variantCount} product variants).`,
      actionType: LOG_TYPES.UPDATE_PRODUCTS,
    };
  },
  [LOG_TYPES.UPDATE_VARIANT]: ({ variantTitle, productTitle }) => {
    return {
      message: `Update variant: Variant ${variantTitle} has been updated (${productTitle} product).`,
      actionType: LOG_TYPES.UPDATE_VARIANT,
    };
  },
  [LOG_TYPES.ADD_SELLING_PLAN]: (sellingPlanTitle) => {
    return {
      message: `Add selling plan ${sellingPlanTitle}`,
      actionType: LOG_TYPES.ADD_SELLING_PLAN,
    };
  },
  [LOG_TYPES.UPDATE_SELLING_PLAN]: (sellingPlanTitle) => {
    return {
      message: `Update selling plan ${sellingPlanTitle}`,
      actionType: LOG_TYPES.UPDATE_SELLING_PLAN,
    };
  },
  [LOG_TYPES.DELETE_SELLING_PLAN]: (sellingPlanTitle) => {
    return {
      message: `Delete selling plan ${sellingPlanTitle}`,
      actionType: LOG_TYPES.DELETE_SELLING_PLAN,
    };
  },
  [LOG_TYPES.ADD_TEMPLATE]: (templateTitle) => {
    return {
      message: `Create template ${templateTitle}`,
      actionType: LOG_TYPES.ADD_TEMPLATE,
    };
  },

  [LOG_TYPES.UPDATE_TEMPLATE]: (templateTitle) => {
    return {
      message: `Update template ${templateTitle}`,
      actionType: LOG_TYPES.UPDATE_TEMPLATE,
    };
  },
  [LOG_TYPES.DELETE_TEMPLATE]: (templateTitle) => {
    return {
      message: `Delete template ${templateTitle}`,
      actionType: LOG_TYPES.DELETE_TEMPLATE,
    };
  },
  [LOG_TYPES.UPDATE_PO_NOTIFICATION_EMAIL]: () => {
    return {
      message: "Update pre-order notification email",
      actionType: LOG_TYPES.UPDATE_PO_NOTIFICATION_EMAIL,
    };
  },
  [LOG_TYPES.UPDATE_SHIPPING_DELAY_EMAIL]: () => {
    return {
      message: "Update shipping delay email",
      actionType: LOG_TYPES.UPDATE_SHIPPING_DELAY_EMAIL,
    };
  },
  [LOG_TYPES.UPDATE_BACK_IN_STOCK_EMAIL]: () => {
    return {
      message: "Update back-in-stock email",
      actionType: LOG_TYPES.UPDATE_BACK_IN_STOCK_EMAIL,
    };
  },
  [LOG_TYPES.DELETE_BIS_NOTIFICATION]: () => {
    return {
      message: "Delete back-in-stock notification",
      actionType: LOG_TYPES.DELETE_BIS_NOTIFICATION,
    };
  },
  [LOG_TYPES.DELETE_ORDER]: (orderTitle) => {
    return {
      message: `Delete order: Order ${orderTitle} has been deleted.`,
      actionType: LOG_TYPES.DELETE_ORDER,
    };
  },
};

export { LOG_ACTIONS, LOG_TYPES, ACTION_TYPE_COLORS };
